import Joi from 'joi';
import { useTranslation } from 'react-i18next';

import FormHeader from '../../../../common/FormHeader';
import useForm from '../../../../../hooks/useForm';
import { renderInput, renderButton } from '../../../../common/renderUtils';
import BackButton from '../BackButton';

const JoinTeam = (props) => {
  const { t } = useTranslation();

  const schema = {
    teamId: Joi.string().required().min(24).label('Team ID'),
  };

  const initialData = { teamId: '' };

  const { data, errors, handleChange, handleSubmit, isFormValid } = useForm(initialData, schema);

  const doSubmit = () => {
    props.onJoinTeam(data.teamId);
  };

  return (
    <form onSubmit={(e) => handleSubmit(e, doSubmit)} className="form-signup">
      <BackButton handler={props.onGoBack} />
      <FormHeader title={t('auth.enterTeamId')} />
      {renderInput('teamId', t('auth.teamId'), 'text', data, errors, handleChange)}
      {renderButton(t('auth.joinTeam'), isFormValid())}
    </form>
  );
};

export default JoinTeam;
